import { countries } from '@common/constants/cnpCountries';

const Helpers = (function () {
  return {
    /**
     * Check is split screen available
     * @returns {boolean} Available or not
     */

    isVerticalScrene() {
      return window.innerWidth < window.innerHeight;
    },

    isSplitScreenAvailable(config) {
      return Helpers.isVerticalScrene() && config.splitScreen && config.splitScreenUrl;
    },

    isSecondScreenAvailable(config) {
      const isDualscreen = sessionStorage.getItem('dualscreen');
      return Helpers.isSplitScreenAvailable(config) || isDualscreen === 'true';
    },

    /**
     * Validate CNP
     * @param   {string}  value CNP
     * @returns {boolean} Valid or not
     */
    validateCNP(value) {
      if (!this.isCNP18plus(value)) return false;

      if (!this.cnpByCountry(value)) return false;

      let i = 0;
      let year = 0;
      let hashResult = 0;
      const cnp = [];
      const hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
      if (value.length !== 13) {
        return false;
      }
      for (i = 0; i < 13; i++) {
        cnp[i] = parseInt(value.charAt(i), 10);
        if (isNaN(cnp[i])) {
          return false;
        }
        if (i < 12) {
          hashResult += (cnp[i] * hashTable[i]);
        }
      }
      hashResult %= 11;
      if (hashResult === 10) {
        hashResult = 1;
      }
      year = (cnp[1] * 10) + cnp[2];
      switch (cnp[0]) {
        case 1:
        case 2:
          year += 1900;
          break;
        case 3:
        case 4:
          year += 1800;
          break;
        case 5:
        case 6:
          year += 2000;
          break;
        case 7:
        case 8:
        case 9:
          year += 2000;
          if (year > (parseInt(new Date().getYear(), 10) - 14)) {
            year -= 100;
          }
          break;
        default:
          return false;
      }
      if (year < 1800 || year > 2099) {
        return false;
      }
      return (cnp[12] === hashResult);
    },

    /**
     * isCNP18plus CNP
     * @param   {string}  value CNP
     * @returns {boolean} Valid or not
     */

    isCNP18plus(value) {
      let i = 0;
      let year = 0;
      let month = 0;
      let day = 0;
      let hashResult = 0;
      const cnp = [];
      const hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
      if (value.length !== 13) {
        return false;
      }
      for (i = 0; i < 13; i++) {
        cnp[i] = parseInt(value.charAt(i), 10);
        if (isNaN(cnp[i])) {
          return false;
        }
        if (i < 12) {
          hashResult += (cnp[i] * hashTable[i]);
        }
      }
      hashResult %= 11;
      if (hashResult === 10) {
        hashResult = 1;
      }
      year = (cnp[1] * 10) + cnp[2];
      month = (cnp[3] * 10) + cnp[4];
      day = (cnp[5] * 10) + cnp[6];

      if (day < 1 || day > 31) return false;
      if (month < 1 || month > 12) return false;

      switch (cnp[0]) {
        case 1:
        case 2:
          year += 1900;
          break;
        case 3:
        case 4:
          year += 1800;
          break;
        case 5:
        case 6:
          year += 2000;
          break;
        case 7:
        case 8:
        case 9:
          year += 2000;
          if (year > (parseInt(new Date().getYear(), 10) - 14)) {
            year -= 100;
          }
          break;
        default:
          return false;
      }

      const adulthDateBirth = new Date(); // date of 18 years old person
      const oldDateBirth = new Date(); // max age of person
      const dateOfPerson = new Date(year, month - 1, day); // date of birth of person

      adulthDateBirth.setFullYear(adulthDateBirth.getFullYear() - 18);
      oldDateBirth.setFullYear(oldDateBirth.getFullYear() - 89);

      if (dateOfPerson <= adulthDateBirth && dateOfPerson >= oldDateBirth) {
        return true;
      }
      return false;
    },

    cnpByCountry(value) {
      const lastTwoChars = value.slice(7, 9);
      const exist = countries[lastTwoChars];
      return !!exist;
    },

    /**
     * @name getWeightedRandom
     * @description returns "weighted" random element of array
     * @param {Array} array the array
     * @param {String} weightFieldName array's objects' field name that contains it's weight
     *
     * @return {Object} random weighted array item
     */
    getWeightedRandom: function getWeightedRandom(array, weightFieldName = 'weight') {
      const variants = [];
      let i;
      array.forEach((item) => {
        if (item.ignore) {
          return;
        }
        for (i = 0; i < (item[weightFieldName] || 1); i++) {
          variants.push(item);
        }
      });

      const index = Math.floor(Math.random() * variants.length);

      return variants[index];
    },
    byOrderSortingFunc: function byOrderSortingFunc(a, b) {
      if (a.order < 0) {
        return 1;
      } if (b.order < 0) return -1;

      return a.order - b.order;
    },

    /**
     * @name Helpers.calculateTaxForReturnedAndProfit
     * @description returns game object from config
     * @param {Number} present
     * @param {Number} amount
     * @return {Number} returns game object from config
     */
    calculateTaxForReturnedAndProfit: function calculateTaxForReturnedAndProfit(config, present, amount, taxRange) {
      let rangeList;
      let result = 0;
      if (taxRange) {
        rangeList = taxRange;
        for (const item of rangeList) {
          const {
            from,
            to,
            entire_amount,
            percent: presentItem,
          } = item;

          if (entire_amount) {
            if (from <= amount && to > amount) {
              result = amount * presentItem / 100;
              break;
            }
          } else if (from < amount && presentItem > 0 && presentItem < 100) {
            if (amount <= to) {
              result += (amount - from) * presentItem / 100;
              break;
            } else {
              result += (to - from) * presentItem / 100;
            }
          }
        }
      } else {
        rangeList = (config.main.taxRange || [{
          range: [0, 100000000000000],
          present,
        }]).sort(({ range: [fromA] }, { range: [fromB] }) => fromA - fromB);
        for (const item of rangeList) {
          const {
            range: [fromAmount, toAmount],
            present: presentItem,
          } = item;
          if (fromAmount < amount && presentItem > 0 && presentItem < 100) {
            if (amount <= toAmount) {
              result += (amount - fromAmount) * presentItem / 100;
              break;
            } else {
              result += (toAmount - fromAmount) * presentItem / 100;
            }
          }
        }
      }
      return result;
    },

    /**
     * @name getHash
     * @description function to generate arrayBuffer(32)
     * @param privateKey  {string}
     * @returns {ArrayBuffer(32)}
     */
    async getHash(privateKey) {
      const seconds = Math.floor(Date.now() / 1000);
      const ts = Math.floor(seconds / 30);
      const message = `_${ts}-${privateKey}`;
      const msgUint8 = new TextEncoder().encode(message);
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map((b) => b.toString(16)
        .padStart(2, '0'))
        .join('');
      return hashHex;
    },

    /**
     * @name objectToArray
     * @description Converts object to array
     * @param {Object} obj
     * @param {String} addKeyNameAsProperty if defined, object key names will be added to array elements with property of this name
     * @param {function} calculator if defined, callback will called for each item and will passed whole object for calculating purpose
     * @returns {Array}
     */
    objectToArray: function objectToArray(obj, addKeyNameAsProperty = null, calculator = null) {
      const arr = [];
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] != null) {
          if (addKeyNameAsProperty) {
            obj[key][addKeyNameAsProperty] = key;
          }
          calculator && calculator(obj[key]);
          arr.push(obj[key]);
        }
      }
      return arr;
    },

    /**
     * @name firstElement
     * @description Returns first element of an object
     * @param {Object} obj
     * @param {boolean|function} sortFunc function to sort object keys (false for no sorting). if not provided, will be sorted by
     * @returns {*}
     */
    firstElement: function firstElement(obj, sortFunc = null, key = null) {
      if (typeof obj !== 'object') {
        return null;
      }
      const keys = Object.keys(obj);
      if (!keys.length) {
        return null;
      }
      if (sortFunc === false) {
        return obj[keys[0]];
      }
      sortFunc = sortFunc || this.byOrderSortingFunc;
      return this.objectToArray(obj, key)
        .sort(sortFunc)[0];
    },
    /**
     * @ngdoc method
     * @name MergeRecursive
     * @methodOf vbet5.service:Utils
     * @description merges 2 objects recursively
     * @param {Object} to destination object
     * @param {Object} from source object
     * @return {Object} returns changed destination object
     */
    mergeRecursive: function mergeRecursive(to, from) {
      let p;
      for (p in from) {
        if (from.hasOwnProperty(p)) {
          try {
            if (from[p].constructor === Object) {
              if (from[p]['@replace'] === true) {
                to[p] = from[p];
                delete to[p]['@replace'];
              } else {
                to[p] = mergeRecursive(to[p], from[p]);
              }
            } else {
              to[p] = from[p];
            }
          } catch (e) {
            to[p] = from[p];
          }
        }
      }
      return to;
    },

    /**
     * @name isNumeric
     * @description Checks if argument is numeric
     * @param {*} n
     * @returns {boolean}
     */
    isNumeric: function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    /**
     * @name addClassName
     * @description It should add class name on the element
     * @param {string} selectors
     * @param {string} setClassName
     */
    addClassName(selectors, setClassName) {
      const element = document.querySelectorAll(selectors)[0];
      if (element && !element.className.includes(setClassName)) {
        element.classList.add(setClassName);
      }
    },
    /**
     * @name removeClassName
     * @description It should remove class name on the element
     * @param {string} selectors
     * @param {string} setClassName
     */
    removeClassName(selectors, setClassName) {
      const element = document.querySelectorAll(selectors)[0];
      if (element && setClassName && element.className.includes(setClassName)) {
        element.classList.remove(setClassName);
      }
    },
    /**
     * @name toggleClassName
     * @description It should toggle class name on the element
     * @param {string} selectors
     * @param {string} setClassName
     */
    toggleClassName(selectors, setClassName) {
      const element = document.querySelectorAll(selectors)[0];
      element.classList.toggle(setClassName);
    },
    /**
     * @name getHashParams
     * @description Returns location hash params
     * @returns {{}}
     */
    getHashParams: function getHashParams() {
      const hashParams = {};
      let e;
      const a = /\+/g; // Regex for replacing addition symbol with a space
      const r = /([^?/&;=]+)=?([^&;]*)/g;
      const d = function (s) {
        return decodeURIComponent(s.replace(a, ' '));
      };
      const q = window.location.hash.substring(1);
      while (e = r.exec(q)) {
        hashParams[d(e[1])] = d(e[2]);
      }
      return hashParams;
    },
    /**
     * @name getQueryStringValue
     * @description Returns location query param
     * @param {String} name of the param
     * @param {String} url to get the param form given string default is current location
     * @returns {String}
     */
    getQueryStringValue(name, url) {
      if (!url) {
        url = window.location.href;
      }
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    /**
     * @name getUriParam
     * @description Returns hash or query param from location
     * @param {string} key
     * @returns {*}
     */
    getUriParam(key) {
      return Helpers.getQueryStringValue(key, null) || (Helpers.getHashParams() || {})[key];
    },
    /**
     * @name GetObjectByStringPath
     * @description Returns part of the object o identified by path s
     * @param {Object} o source object
     * @param {String} s path (e.g. "data.messages")
     * @returns {*}
     */
    GetObjectByStringPath: function GetObjectByStringPath(o, s) {
      s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
      s = s.replace(/^\./, ''); // strip a leading dot
      const a = s.split('.');
      for (let i = 0, n = a.length; i < n; ++i) {
        const k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    },
    /**
     * @name CheckIfPathExists
     * @description Returns part of the object o identified by path s
     * @param {Object} o source object
     * @param {String} path (e.g. "data.messages")
     * @returns {boolean}
     */
    CheckIfPathExists(o, path) {
      try {
        return Boolean(Helpers.GetObjectByStringPath(o, path));
      } catch (e) {
        return false;
      }
    },

    /**
     * @name checkStatus
     * @description helper function to check request status and throw exception when something is wrong
     * @param {Object} response
     * @returns {Object | Undefined}
     */
    checkStatus(response) {
      if (response.status >= 200 && response.status < 300) {
        return response;
      }
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    },

    getRouteType(pathname) {
      return {
        casino: 'casino',
        'live-casino': 'casino',
        games: 'casino',
        'free-quiz': 'casino',
        game: 'sport',
        live: 'sport',
        prematch: 'sport',
        poker: 'zharmar',
        asian_prematch: 'sport',
        asian_live: 'sport',
        asian_today: 'sport',
        '': 'home',
      }[pathname.split('/')[1]];
    },
    hasClassName(selector, currentClassName) {
      const element = document.querySelectorAll(selector)[0];
      return [...element.classList].indexOf(currentClassName) > 0;
    },
  };
}());

export const dynamicPrice = (config, price, currencyId, dotted = true) => {
  const amount = dotted ? price.toLocaleString() : price;

  if (config.useCurrencySymbol && config.currencySymbol[currencyId]) {
    return `${config.currencySymbol[currencyId]}${amount}`;
  }

  return `${amount} ${currencyId}`;
};

export const normalizeISO = (isoString) => {
  if (isoString.endsWith('Z')) return isoString;
  return `${isoString}Z`;
};

export default Helpers;
